import { globalAxiosInstance } from "../../apiCalls/utils/axios";
import { makeRequest } from "../../apiCalls/utils/makeRequest";
import {
  SMSCommand,
  SMSCommandResponse,
} from "../../pages/smsCommands/smsTypes";

export const useGetSMSCommands = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  buildQuery: () => "/sms_command_templates",
  axiosInstance: globalAxiosInstance,
  method: "get",
  withInitialLoading: true,
  transformResponse: (response: SMSCommandResponse) => response?.data,
});

export const useGetSMSCommand = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  buildQuery: (data) => `/sms_command_templates/${data.data}`,
  axiosInstance: globalAxiosInstance,
  method: "get",
  withInitialLoading: false,
  transformResponse: (response: SMSCommandResponse) => response?.data,
});

export const useCreateSMSCommand = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  buildQuery: () => "/sms_command_templates",
  buildData: (data) => data,
  axiosInstance: globalAxiosInstance,
  method: "post",
});

export const useUpdateSMSCommand = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  buildQuery: ({ data }) => `/sms_command_templates/${data?.id}`,
  buildData: (data: SMSCommand) => data,
  axiosInstance: globalAxiosInstance,
  method: "put",
});

export const useDeleteSMSCommand = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  axiosInstance: globalAxiosInstance,
  method: "delete",
  buildQuery: ({ data }) => `/sms_command_templates/${data}`,
});
